import { VariablesOf } from 'gql.tada';
import { DocumentNode } from 'graphql';

export default function getRequestId<QueryType extends DocumentNode>(
  query: QueryType,
  variables: VariablesOf<QueryType>
) {
  const operation = query.definitions.find((def) => def.kind === 'OperationDefinition');

  const operationName = operation?.name?.value || 'Unknown';

  const variablesId = Object.entries(variables)
    .map(([key, value]) => `${key}:${value}`)
    .join(',');

  return `${operationName}[${variablesId}]`;
}
